import { forwardRef } from "react";

const time = (value) => {
    const date = new Date(value);
    return Number.isNaN(date.getTime())
        ? ''
        : date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

/**
 * Lista de mensajes de una superficie del chat.
 *
 * Distingue tres orígenes porque cada uno se lee distinto: lo que escribió el
 * propio usuario, lo que escribió la modelo y los avisos automáticos (propinas
 * y errores), que no son de nadie y van centrados.
 */
const ChatMessages = forwardRef(({ messages, currentUserId, emptyText }, ref) => (
    <div className="chat-messages-container" ref={ref}>
        {messages.length === 0 && (
            <p className="chat-empty">{emptyText}</p>
        )}

        {messages.map((message) => {
            const isSystem = message.kind === 'system' || message.kind === 'tip';
            const isOwn = !isSystem && message.user_id === currentUserId;

            const classes = [
                'chat-message',
                isOwn ? 'message-own' : '',
                !isOwn && message.is_model ? 'message-model' : '',
                isSystem ? 'message-system' : '',
                message.kind === 'tip' ? 'message-tip' : ''
            ].filter(Boolean).join(' ');

            return (
                <div key={message.id} className={classes}>
                    <div className="message-header">
                        <span className="message-username">{message.user_name}</span>
                        <span className="message-time">{time(message.timestamp)}</span>
                    </div>
                    <div className="message-bubble">
                        {message.kind === 'tip' && <i className="fa-solid fa-coins me-2"></i>}
                        {message.message}
                    </div>
                </div>
            );
        })}
    </div>
));

export default ChatMessages;
